//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const PageEditorValidateButton: FeatureFlag = {"Id":"PageEditorValidateButton","Label":"[10.27]Show a Validate button in the page/form editor","Impact":"Rollout control for the admin builder only. When enabled, the page/form editor's top nav shows a \"Validate\" button that re-validates without saving a draft/publish, and moves focus to the first resulting error. When disabled (the default), the button is absent and the previous behavior is preserved.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
